module.exports = __webpack_public_path__ + "resources/img/isms.5a9500498204bb946071dedd60eef8c9.png";